import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { FullPageStatus } from "@/components/FullPageStatus";
import { takeOAuthState, useAuth } from "./AuthContext";

export function Callback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { completeLogin, markSilentRenewFailed } = useAuth();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) {
      return;
    }

    hasRun.current = true;

    const code = searchParams.get("code");
    const error = searchParams.get("error");
    const state = searchParams.get("state");
    const { expectedState, returnPath } = takeOAuthState();

    void (async () => {
      const isStateValid = expectedState !== null && state === expectedState;

      if (!isStateValid) {
        markSilentRenewFailed();
        navigate("/", { replace: true });

        return;
      }

      if (code) {
        try {
          await completeLogin(code);
        } catch {
          markSilentRenewFailed();
        }
      } else if (error) {
        markSilentRenewFailed();
      }

      navigate(returnPath ?? "/", { replace: true });
    })();
  }, [completeLogin, markSilentRenewFailed, navigate, searchParams]);

  return <FullPageStatus title="Loading..." />;
}
